import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/components/site/data";

export default function Testimonials() {
  return (
    <section id="stories" className="bg-[#efe9de] py-24 md:py-36 border-y border-black/10" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-2xl">
          <p className="overline mb-5">Client Stories</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#1a1a17] tracking-tight">
            Trust, <span className="italic text-[#0e5b45]">earned</span> over years
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="bg-white border border-black/10 p-8 lg:p-9 flex flex-col hover:border-[#0e5b45]/40 transition-colors duration-500"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={30} className="text-[#0e5b45] mb-6" strokeWidth={1.4} />
              <blockquote className="font-serif text-lg md:text-xl text-[#1a1a17]/90 leading-relaxed italic flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-black/10">
                <p className="text-[#1a1a17] font-medium">{t.name}</p>
                <p className="text-sm text-stone-500 mt-1">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
